import { MediaTypeEnum } from "@jnext/ts-axios-contestformat";
import {ProductPreviewDto} from "@jnext/ts-axios-formatdigitalcollection";

export function getThumbnailImage(product?: ProductPreviewDto) {
    return product?.mediaContents?.filter(e => e.mediaType === MediaTypeEnum.Image)?.find(el => el.flPreview == true)?.mediaUrl;
}

export function getBaseImage(product?: ProductPreviewDto) {
    return product?.mediaContents?.filter(e => e.mediaType === MediaTypeEnum.Image)?.find(el => el.flDefault == true)?.mediaUrl;
}

export function getProductFallBackImage(product?: ProductPreviewDto) {
    return product?.mediaContents?.filter(e => e.mediaType === MediaTypeEnum.Image)?.[0]?.mediaUrl;
}
export function getProductImage(product?: ProductPreviewDto){
    return getThumbnailImage(product) || getBaseImage(product) || getProductFallBackImage(product);
}

export function getBrand(product?: ProductPreviewDto) {
    return product?.brands?.[0];
}

export function getBrandLogo(product?: ProductPreviewDto) {
    return product?.brands?.[0]?.brandLogo;
}